import * as yup from 'yup';
import i18n from 'i18next';

const pilotFormSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required(() => i18n.t('common.message.requiredField')),
  licenseNumber: yup
    .string()
    .trim()
    .required(() => i18n.t('common.message.requiredField')),
  isDeleted: yup.bool(),
});

export default pilotFormSchema;
